import styled from "styled-components";
export const TripsWrapper = styled.div`
  width: 35%;
  height: 82vh;
  border-radius: 7px;
  overflow: hidden;
  background-color: white;
  box-shadow: 3px 3px 10px rgba(40, 40, 40, 0.1);

  @media (max-width: 992px) {
    width: 100%;
    height: 50vh; /* adjust for mobile */
    margin-top: 1rem;
  }
`;

export const TripsContainer = styled.div`
  background-color: white;
  padding: 1rem;
  border-radius: 7px;
  width: 100%;
  height: 82vh;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: stretch;
  overflow-y: auto;

  scrollbar-width: thin;
  scrollbar-color: #888 white;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  @media (max-width: 992px) {
    height: 50vh; /* shorter on mobile */
  }
`;